export default __webpack_public_path__ + "static/media/location.f62b2969.svg";